import React, {useEffect, useState} from 'react';
import {getTermsPaged} from "../../services/TermRepository";
import {CMSHeader} from "./CMSHeader";


export function QuizAdmin() {

    const [quizzes, setQuizzes] = useState([]);
    const [page, setPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);


    useEffect(() => {
        getTermsPaged(page).then(result => {
            setQuizzes(result.content)
            setTotalPages(result.totalPages)
        }).catch(err => console.log(err.message))
    }, [page]);

    return (
        <div>

            <CMSHeader page={page} maxPage={totalPages} setPage={setPage} context={"Quiz"}/>
            <div className={"container pt-3"}>
                {
                    quizzes.map(quiz => (
                        <div>
                        </div>
                    ))
                }
            </div>
        </div>


    );


}